import React, { useState, useEffect } from "react";
// react plugin for creating charts
// import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// import Icon from "@material-ui/core/Icon";
// @material-ui/icons
// import CheckBoxOutlineBlankRounded from "@material-ui/icons/CheckBoxOutlineBlankRounded";
// import Warning from "@material-ui/icons/Warning";
// import DateRange from "@material-ui/icons/DateRange";
// import LocalOffer from "@material-ui/icons/LocalOffer";
// import Update from "@material-ui/icons/Update";
// import ArrowUpward from "@material-ui/icons/ArrowUpward";
// import AccessTime from "@material-ui/icons/AccessTime";
// import Accessibility from "@material-ui/icons/Accessibility";
// import BugReport from "@material-ui/icons/BugReport";
// import Code from "@material-ui/icons/Code";
// import Cloud from "@material-ui/icons/Cloud";
import Group from "@material-ui/icons/Group";
// import Person from "@material-ui/icons/Person";
// import ShowChart from "@material-ui/icons/ShowChart";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Table from "components/Table/Table.js";
// import Tasks from "components/Tasks/Tasks.js";
// import CustomTabs from "components/CustomTabs/CustomTabs.js";
// import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
// import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

// import { bugs, website, server } from "variables/general.js";

// import {
//   // dailySalesChart,AdminCheckdata
//   // emailsSubscriptionChart,
//   // completedTasksChart,
// } from "variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/AdmindashboardStyle.js";
// import { Icon } from "@material-ui/core";

const useStyles = makeStyles(styles);

import { Form, Row, Col } from "react-bootstrap";
// Import Service
// import RegsugarService from "../../services/regsugar.service";
import FarmerMasterService from "../../services/farmermaster.service";
// import OcsbService from "../../services/ocsb.service";
import authService from "../../services/auth.service";
import TimeregService from "../../services/timereg.service";
import LoadingAlert from "../../components/LoadingAlert";

export default function StaffMasterDashboard() {
  const [timeregList, setTimeregList] = useState([]);
  const [timeregSelect, setTimeregSelect] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);

  const approveNumber = data.filter(function (element) {
    return element.approve_status == "อนุมัติ";
  });
  const notApproveNumber = data.filter(function (element) {
    return element.approve_status == "ไม่อนุมัติ";
  });
  const waitApproveNumber = data.filter(function (element) {
    return element.approve_status == "รออนุมัติ";
  });
  const documentApproveNumber = data.filter(function (element) {
    return element.approve_status == "ขอเอกสาร";
  });
  const draffApproveNumber = data.filter(function (element) {
    return element.approve_status == "ฉบับร่าง";
  });
  const user = authService.getCurrentUser();
  const getData = (user_reg, timereg_id) => {
    if (timereg_id == 0) {
      setData([]);
    } else {
      setLoading(true);
      FarmerMasterService.getFarmerMaster(user_reg, timereg_id)
        .then((response) => {
          setData(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching data: ", error);
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleTimeregChange = (e) => {
    setTimeregSelect(e.target.value);
    getData(user.user.user_reg, e.target.value);
  };
  const getTimeRegList = () => {
    TimeregService.getTimereglist(user.user.user_reg)
      .then((response) => {
        setTimeregList(response.data.data);
      })
      .catch((err) => {
        console.log("fetch timereg List Error :" + err);
      });
  };

  useEffect(() => {
    getTimeRegList();
  }, []);

  const classes = useStyles();
  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}
      <Row>
        <Form.Label column sm={2}>
          รอบการจดทะเบียน :
        </Form.Label>
        <Col md={4}>
          <Form.Group>
            <Form.Select
              name="approve_status"
              value={timeregSelect}
              onChange={handleTimeregChange}
            >
              <option value="0">เลือกรอบที่จดทะเบียน</option>
              {timeregList.map((a) => (
                <option key={a.timereg_id} value={a.timereg_id}>
                  {a.timereg_desc}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <GridContainer>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                {/* <Icon>{Person}</Icon> */}
                <Group />
              </CardIcon>
              <p className={classes.cardCategory}>อนุมัติ</p>
              <h3 className={classes.cardTitle}>
                {approveNumber.length.toLocaleString("en-US")} <small>คน</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {/* <Danger>
                  <Warning />
                </Danger>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  Get more space
                </a> */}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <Group />
              </CardIcon>
              <p className={classes.cardCategory}>ไม่อนุมัติ</p>
              <h3 className={classes.cardTitle}>
                {notApproveNumber.length.toLocaleString("en-US")}{" "}
                <small>คน</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {/* <DateRange />
                Last 24 Hours */}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Group />
              </CardIcon>
              <p className={classes.cardCategory}>รออนุมัติ</p>
              <h3 className={classes.cardTitle}>
                {waitApproveNumber.length.toLocaleString("en-US")}{" "}
                <small>คน</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {/* <DateRange />
                Last 24 Hours */}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Group />
              </CardIcon>
              <p className={classes.cardCategory}>ขอเอกสาร</p>
              <h3 className={classes.cardTitle}>
                {documentApproveNumber.length.toLocaleString("en-US")}{" "}
                <small>คน</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {/* <DateRange />
                Last 24 Hours */}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning" style={{ background: "gray" }}>
                <Group />
              </CardIcon>
              <p className={classes.cardCategory}>ฉบับร่าง</p>
              <h3 className={classes.cardTitle}>
                {draffApproveNumber.length.toLocaleString("en-US")}{" "}
                <small>คน</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                {/* <DateRange />
                Last 24 Hours */}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
